import moment from 'moment';

export default {

    currentSearchTerm: (state, getters) => {
        return state.searchTerm;
    },
    darkMode() {
        return true;
    },
    defaultLanguage() {
        return 'en';
    },
    displayAppSearchBar() {
        return false;
    },

    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },
    displayChooseEntityFullOverlay(){
        // DO NOT DISPLAY view Choose Entity
        return false;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration(){
        return false;
    },
    enableUsersAdministration(){
        return false;
    },
    enablePermissionAdministration(){
        return false;
    },
    enableGroupsSideBarMenu(){
        return false;
    },
    enableUsersSideBarMenu(){
        return true;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return false;
    },
    enableSidebarCollapse(){
        return false;
    },
    enableLoginByEmail(){
        return false;
    },
    enableCreateUser(){
        return true;
    },
    enableCreateGroup(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },
    displaySidebarHorizontalsButtons(){
        return false;
    },

    // Pictures
    loginImage() {
        return '/static/img/loginImage.png';
    },
    // backgroundFile1() {
    //     return '/static/img/backgroundFile1.jpg';
    // },
    // backgroundFile2() {
    //     return '/static/img/backgroundFile2.jpg';
    // },
    logoFile(state) {
        if(state.imageAssets['sidebar-image']){
            return state.imageAssets['sidebar-image'];
        }
        return '/static/img/logoFile.jpg';
    },
    logoFileTopHeader() {
        return '/static/img/logos.png';
    },
    // logoFileBackgroundColor(/*state, getters, rootState*/) {
    //     return 'transparent';
    // },
    // logoFileTopHeader(/*state, getters*/) {
    //     // return getters.currentEntity.logo_file_topHeader;
    //     return ImageBase64.logoFileTopHeader;
    // },
    logoFileTopHeaderBackgroundColor(/*state, getters*/) {
        return '#222';
    },
    sidebarName() {
        return 'Live Delivery';
    },

};



// WEBPACK FOOTER //
// ./src/store/getters.js